import React, { useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosService";
import { NewPrefilter } from "./PreFilter";

const HttpTemplatePrefilter = ({ prefiltersWithFormula, onChange, templateId, valueOptions }) => {
  const [loading, setLoading] = useState(true);
  const [templateFields, setTemplateFields] = useState([]);
  const [tableObject, setTableObject] = useState(null);

  useEffect(() => {
    const fetchTemplateData = async () => {
      try {
        setLoading(true);
        if (!templateId) {
          setTemplateFields([]);
          setTableObject(null);
          return;
        }

        const { data } = await axiosInstance.get("/http-request-templates");
        const template = data.find((t) => t.id === templateId);

        if (!template) {
          setTemplateFields([]);
          setTableObject(null);
          return;
        }

        const fields =
          template.http_output_variable_bindings?.map((b) => ({
            id: b.name,
            display: b.name,
            type: "field",
            data_type: "text"
          })) || [];

        setTemplateFields(fields);

        const tableObj = {};
        fields.forEach((f) => {
          tableObj[f.id] = { ...f, field_type: f.data_type };
        });
        setTableObject(tableObj);
      } catch (error) {
        console.error("Error fetching HTTP template data", error);
        setTemplateFields([]);
        setTableObject(null);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplateData();
  }, [templateId]);

  if (!templateId) {
    return <div>Please select template</div>;
  }

  if (loading) {
    return <div>Loading pre-filter data...</div>;
  }

  console.log(valueOptions, tableObject);

  return (
    <NewPrefilter
      prefiltersWithFormula={prefiltersWithFormula}
      tableId={templateId}
      tableType="http-template"
      handleChange={onChange}
      filterValues={templateFields}
      valueOptions={valueOptions}
      tableObject={tableObject}
    />
  );
};

export default HttpTemplatePrefilter;
